<template lang="pug">
  .b2b-page-documentacion
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-button(
                v-if='documentationDetailForm.hasPath!=null',
                icon='ods-icon-download',
                size='small',
                circle,
                @click.native='handleDownload')
                | {{ $t('buttons.btnDownload') }}
              ods-button(
                icon='ods-icon-refresh',
                size='small',
                circle,
                @click.native='handleUpload')
                | {{ $t('buttons.btnAdd') }}
              ods-button(
                v-if='canAdminIndra'
                icon='ods-icon-delete',
                size='small',
                circle,
                @click.native='handleErase')
                | {{ $t('documentation_detail.buttons.eraseDocument') }}
      ods-form(
        ref='documentationDetailForm',
        :model='documentationDetailForm',
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("documentation_detail.documentation_detail_form.project")',
              prop='project')
              ods-input(
                v-model='documentationDetailForm.project'
                :disabled='true')
            ods-form-item(
              :label='$t("documentation_detail.documentation_detail_form.category")',
              prop='category')
              ods-input(
                v-model='formatCategory',
                :disabled='true')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("documentation_detail.documentation_detail_form.name")',
              prop='name')
              ods-input(
                v-model='documentationDetailForm.name'
                :disabled='true')
            ods-form-item(
              :label='$t("documentation_detail.documentation_detail_form.language")',
              prop='language')
              ods-input(
                v-model='formatLanguage',
                :disabled='true')
    ods-dialog(
      ref='dialogAddDocumentation',
      :title='$t("documentation.dialog_add_documentation.title")',
      :visible.sync='isShowDialogAddDocumentation',
      :append-to-body='true',
      @close='handleCloseDialog',
      width='40%')
      ods-form(
        ref='formDialogAddDocumentation',
        :rules='rulesDialogAddDocumentation',
        :model='formDialogAddDocumentation',
        size='mini')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
          v-model='formDialogAddDocumentation.fichero',
          ref='upload',
          action='#',
          :auto-upload='false',
          :on-change='onSuccessUpload',
          :on-remove='handleRemoveUpload',
          :file-list='fileList')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle)
              | {{ $t('msg_generics.file_selected') }}
      span.dialog-footer(slot='footer')
      ods-button.add-documentation-button(
        style='float: right;',
        type='primary',
        @click.native='onSubmitAddDocumentation("formDialogAddDocumentation")')
        | {{ $t('msg_generics.load_document') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-documentation',
  mixins: [Utils],
  data () {
    return {
      id: '',
      fileList: [],
      isShowDialogAddDocumentation: false,
      documentationDetailForm: {
        project: '',
        name: '',
        category: '',
        language: '',
        hasPath: false
      },
      formDialogAddDocumentation: {
        fichero: null
      },
      // Reglas Validación
      rulesDialogAddDocumentation: {
        fichero: [
          {
            required: true,
            message: this.$t(
              'pendingtask.pendingtask_detail.attachments_table.fileselected'
            ),
            trigger: 'click'
          }
        ]
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {

    ...mapGetters([
      'canAdminIndra'
    ]),

    formatCategory () { // eslint-disable-line
      if (this.documentationDetailForm.category) {
        return this.$t('documentation_category.' + this.documentationDetailForm.category)
      }
    },

    formatLanguage () { // eslint-disable-line
      if (this.documentationDetailForm.language) {
        return this.$t('documentation_language.' + this.documentationDetailForm.language)
      }
    }

  },

  watch: {
    '$route' (to) {
      this.id = to.params.idDocumentation
    }
  },

  methods: {
    ...mapActions([
      'getDocumentationById',
      'downloadDocumentationMultiple',
      'deleteDocument',
      'handleUploadDocumentation'
    ]),

    // Desargar
    async handleDownload () {
      console.log('handleDownload() ->')
      const load = this.$loading({
        lock: true,
        text: this.$t('documentation_detail.load.download')
      })
      try {
        const filename = await this.downloadDocumentationMultiple([this.id])
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownload CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleErase () {
      this.$confirm(this.$t('documentation_detail.confirm.title_delete_documentation'), {
        confirmButtonText: this.$t('documentation_detail.confirm.confirm_button_delete_documentation'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('documentation_detail.load.delete_document')
        })
        try {
          await this.deleteDocument(this.id)
          this.$notify({
            title: this.$t('documentation_detail.notify.delete_document_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          router.push({ name: 'documentacion-documentos-table' })
        } catch (error) {
          console.log('removeDocument CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },

    async handleUpload () {
      this.$confirm(this.$t('documentation_detail.confirm.title_upload_documentation'), {
        confirmButtonText: this.$t('documentation_detail.confirm.confirm_button_upload_documentation'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('documentation_detail.load.upload_document')
        })
        try {
          this.isShowDialogAddDocumentation = true
        } finally {
          load.close()
        }
      }).catch(() => {})
    },
    // Reseteo al cerrar dialogo
    handleCloseDialog () {
      this.$refs.formDialogAddDocumentation.resetFields()
      this.handleRemoveUpload()
      this.formDialogAddDocumentation.fichero = null
    },
    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },
    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddDocumentation.fichero = file
      this.$refs.formDialogAddDocumentation.validateField('fichero')
    },
    onSubmitAddDocumentation (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('onSubmitAddDocumentation!!!   ', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_attachment')
          })
          try {
            const query = {
              documentation: this.fileList[0],
              id: this.id,
              name: this.documentationDetailForm.name,
              projectId: this.documentationDetailForm.idProject,
              categoryId: this.documentationDetailForm.idCategory,
              languageId: this.documentationDetailForm.idLanguage
            }
            await this.handleUploadDocumentation(query)
            this.$notify({
              title: this.$t('documentation_detail.notify.upload_document_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.documentationDetailForm = await this.getDocumentationById(this.$route.params.idDocumentation)
          } catch (error) {
            console.log('onSubmitAddDocumentation CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.isShowDialogAddDocumentation = false
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })

    try {
      // Get documentation
      this.documentationDetailForm = await this.getDocumentationById(this.$route.params.idDocumentation)
      this.id = this.$route.params.idDocumentation
    } catch (error) {
      console.log('getDocumentationById CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-documentacion{
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
